import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import colunms from "../../../Components/assets/icons/LINES.png";
import pen from "../../../Components/assets/icons/pen.png";
import eye from "../../../Components/assets/icons/eye.png";
import basket from "../../../Components/assets/icons/basket.png";
import search1 from "../../../Components/assets/icons/search.png";
import top from "../../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import circle from "../../assets/icons/circle.png";
import rigth from "../../assets/icons/rigth.png";
import save from "../../assets/icons/save.png";
import cancel from "../../assets/icons/cross.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../../Header/Header";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Offcanvas from "react-bootstrap/Offcanvas";

import toast, { Toaster } from "react-hot-toast";
import Card from "react-bootstrap/Card";
import Select from "react-select";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import { Context } from "../../../utils/context";
import { FaEye } from "react-icons/fa";
import Pagination from "react-bootstrap/Pagination";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import EditUserCommision from "./userCommission";
import PriceEditOffCanvance from "./PriceEdit";
import ModelBulkUpload from "../../common/ModelBulkUpload";
import { postData } from "../../../utils/api";
import { ClipLoader } from "react-spinners";
library.add(fas);

// ********************************************************************************************************************************************************

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    IMG_URL,
    Per_Page_Dropdown,
    Select2Data,
    usertype,

    getDownloadDataExcel,
  } = useContext(Context);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [userCommision, setUserCommision] = useState(0);
  const [option, setOption] = useState();
  const [searchByUser, setSearchByUser] = useState(null);
  const [searchCategory, setSearchCategory] = useState("");
  const [searchVendor, setSearchVendor] = useState("");
  const [searchSubCategory, setSearchSubCategory] = useState("");
  const [searchChildSubCategory, setSearchChildSubCategory] = useState("");
  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    setSearchByUser(id || null); // Set to null if id is undefined or null
    getDataAll();
  }, [id]);

  useEffect(() => {
    getDataAll();
  }, [searchByUser]);

  const [user, setUser] = useState({});
  const GetUserData = async () => {
    const response = await getData(`/usersingleget`);
    if (response?.success) {
      setUser(response?.data);
    }
  };
  useEffect(() => {
    GetUserData();
  }, []);

  const [changeStatus, setChangeStatus] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const [totalPages, settotalPages] = useState();

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>,
    );
  }

  const getDataAll = async () => {
    const queryString = `/product?page=${onPageChange}&per_page=${perPage}&term=${search}&searchByUser=${searchVendor?.value || id}&searchCategory=${
      searchCategory?.value || ""
    }&searchSubCategory=${
      searchSubCategory?.value || ""
    }&searchChildSubCategory=${searchChildSubCategory?.value || ""}&searchVendor=${searchVendor?.value || ""}`;
    const response = await getData(queryString);
    await setData(response);
    setCurrentPage(response?.data?.currentPage);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    settotalPages(response?.data?.totalPages);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));

    const newData = response?.data?.data;
    if (newData) {
      const newIds = newData.map((d) => d?.id);
      setAllChecked(newIds);
    }
  };
  useEffect(() => {
    getDataAll();
  }, [
    changeStatus,
    perPage,
    reset,
    show,
    show1,
    userCommision,
    // search,
    // searchCategory,
    // searchSubCategory,
    // searchChildSubCategory,
    onPageChange,
  ]);

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value)),
        );
      }
    }
  };

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/product/${id}`);
    setChangeStatus(response);
  };

  const ChangeOfferStatus = async (id) => {
    const response = await editStatusData(`/product/offerproduct/${id}`);
    setChangeStatus(response);
  };

  const ChangePopularProduct = async (id) => {
    const response = await editStatusData(`/product/popularproduct/${id}`);
    setChangeStatus(response);
  };

  // Delete module.....................................................
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  // Modal function
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  const handleCloseUserCommision = () => setUserCommision(0);
  const handleShowUserCommision = (id) => {
    setUserCommision(id);
  };
  const [showPrice, setShowPrice] = useState(0);
  const handleClosePrice = () => setShowPrice(0);
  const handleShowPrice = (id) => {
    setShowPrice(id);
  };

  const DeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(`/product/${recordToDeleteId}`);
      await ErrorNotify(recordToDeleteName);
      setChangeStatus(response);
      setRecordToDeleteId(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
  };

  //toggle/
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
    col9: true,
    col10: true,
    col11: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const [categories, setCategories] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [childSubCategories, setChildSubCategories] = useState([]);
  const Select3Data = async (data, name, other = false) => {
    const result = data?.map((data) => ({
      value: data?.id,
      label: data?.first_name,
      name: name,
    }));

    if (other) {
      result.push({ value: "0", label: "Other", name: name });
    }
    return result;
  };
  const GetAllVendor = async () => {
    const response = await getData("/all-sellers");

    if (response?.success) {
      setVendors(await Select3Data(response?.data, "category_id"));
    }
  };
  const GetAllCategory = async () => {
    let response;
    if (user?.type === "Seller") {
      response = await getData("/allsellercategories");
    } else {
      response = await getData("/allcategories");
    }

    if (response?.success) {
      setCategories(await Select2Data(response?.data, "category_id"));
    }
  };

  const GetAllSubCategory = async (id) => {
    const response = await getData(`/allsubcategories/${id}`);
    if (response?.success) {
      setSubCategories(await Select2Data(response?.data, "sub_category_id"));
    }
  };

  const GetAllChildSubCategory = async (id) => {
    const response = await getData(`/allchildsubcategories/${id}`);
    if (response?.success) {
      setChildSubCategories(
        await Select2Data(response?.data, "child_sub_category_id"),
      );
    }
  };

  useEffect(() => {
    GetAllVendor();
    GetAllCategory();
  }, []);

  const HandleDownload = async () => {
    if (selectAllChecked.length == 0) {
      alert("Please Select Atleast One Record");
    } else {
      try {
        await getDownloadDataExcel(
          "/product/download",
          selectAllChecked,
          "Product List",
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [showoff, setShowoff] = useState(false);
  const [loader, setLoder] = useState(false);
  const BulkUpload = async (e) => {
    try {
      setLoder(true);
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      const response = await postData("/product/bulk-product", formData, {});
      if (response?.success) {
        setLoder(false);
        setShowModal({ code: response.code, message: response.message });
      } else {
        setLoder(false);
        setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        setShowoff(response.data);
      }, 1000);
      getDataAll();
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Products"} link={"/employee/employee_details"} />
        <section className="AdvanceDashboard">
          <div className="row MainRowsec me-0 ms-0">
            <section className="Tabels tab-radio tab-radio ">
              <div className="">
                {/* container */}
                <div className="row me-0 ms-0">
                  <div className="d-flex align-items-center gap-2">
                  {isAllow.includes(88) && user?.type === "Seller" ? (
                    <div className="add_info_btn_holder">
                      <Link
                        // to="/employee/employee_details/add"
                        type="button"
                        className="btn btn-add pe-3"
                      >
                        <div className="add me-3">
                          <div onClick={() => handleShow()}>
                            <p className="add-sub-txttt">
                              {" "}
                              <img
                                src={plus}
                                className="plus me-2 ms-0"
                                alt=""
                              />
                              Add Product
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ) : (
                    <></>
                  )}
                  {user?.id !== 1 && (
                    <>
                      {" "}
                      {loader ? (
                        <>
                          <div className="text-center">
                            <ClipLoader />
                          </div>
                        </>
                      ) : (
                        <div className="add me-3">
                          <button
                            className="btn btn-add pe-3"
                            onClick={() =>
                              document.getElementById("PinCodesFile").click()
                            }
                          >
                            Bulk Upload
                          </button>

                          <input
                            type="file"
                            id="PinCodesFile"
                            onChange={(e) => {
                              BulkUpload(e);
                              e.target.value = "";
                            }}
                            accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            style={{ display: "none" }}
                          />
                        </div>
                      )}
                    </>
                  )}</div>

                  <div className="row mt-4 me-0 ms-0">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                      <div className="d-flex">
                        <div className="show me-2">
                          <p className="show mt-1">Show</p>
                        </div>
                        <div className="number me-2">
                          <select
                            className="form-select form-select-sm"
                            aria-label=".form-select-sm example"
                            onChange={(e) => setperPage(e.target.value)}
                          >
                            {option?.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="entries">
                          <p className="show mt-1">entries</p>
                        </div>
                      </div>
                    </div>

                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                      <div className="row">
                        <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-4 col-sm-6 col-12 mt-lg-3  mt-md-3 mt-3">
                          <div className="sowing me-2">
                            <p className="show mt-2">{`Showing ${Math.min(
                              (currentPage - 1) * perPage + 1,
                            )} to ${Math.min(
                              currentPage * perPage,
                              data?.data?.totalEntries,
                            )} of ${data?.data?.totalEntries} entries`}</p>
                          </div>
                        </div>
                        {user?.id === 1 && (
                          <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-4 col-sm-6 col-12 mt-lg-3  mt-md-3 mt-3">
                            <div className="num me-2">
                              <Select
                                isSearchable
                                options={vendors}
                                value={searchVendor}
                                placeholder="Select Vendor"
                                onChange={(e) => {
                                  setSearchVendor(e);
                                }}
                              />
                            </div>
                          </div>
                        )}

                        <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-4 col-sm-6 col-12 mt-lg-3  mt-md-3 mt-3">
                          <div className="num me-2">
                            <Select
                              isSearchable
                              options={categories}
                              value={searchCategory}
                              placeholder="Select Category"
                              onChange={(e) => {
                                setSearchCategory(e);
                                GetAllSubCategory(e.value);
                                setSearchSubCategory("");
                                setSearchChildSubCategory("");
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-4 col-sm-6 col-12 mt-lg-3  mt-md-3 mt-3">
                          <div className="num me-2">
                            <Select
                              isSearchable
                              options={subCategories}
                              value={searchSubCategory}
                              placeholder="Select Sub Category"
                              onChange={(e) => {
                                setSearchSubCategory(e);
                                GetAllChildSubCategory(e.value);
                                setSearchChildSubCategory("");
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-4 col-sm-6 col-12 mt-lg-3  mt-md-3 mt-3">
                          <div className="num me-2">
                            <Select
                              isSearchable
                              options={childSubCategories}
                              value={searchChildSubCategory}
                              placeholder="Select Child Category"
                              onChange={(e) => {
                                setSearchChildSubCategory(e);
                              }}
                            />
                          </div>
                        </div>
                        {/* <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-4 col-sm-6 col-12 mt-lg-3  mt-md-3 mt-3">

                          </div> */}
                        <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-4 col-sm-6 col-12 mt-lg-3  mt-md-3 mt-3">
                          <div className="num me-2 text-end">
                            <input
                              type="text"
                              className="form-control"
                              id=""
                              value={search}
                              placeholder="Product"
                              onChange={(e) => {
                                setSearch(e.target.value);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-4 col-sm-6 col-12 mt-lg-3  mt-md-3 mt-3">
                          <div className="Search me-2">
                            <Button
                              type="button"
                              onClick={getDataAll}
                              className="btn btn-search"
                            >
                              <img src={search1} className="search" alt="" />
                            </Button>
                          </div>
                        </div>
                        <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-4 col-sm-6 col-12 mt-lg-3  mt-md-3 mt-3">
                          <div className="Search-1">
                            <button
                              type="button"
                              onClick={() => {
                                setSearch("");
                                setSearchCategory("");
                                setSearchSubCategory("");
                                setSearchChildSubCategory("");
                                setSearchVendor("");
                                setReset(!reset);
                              }}
                              className="btn btn-reset me-2"
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                        <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-4 col-sm-6 col-12 mt-lg-3  mt-md-3 mt-3">
                          <button
                            className="btn btn-success"
                            onClick={HandleDownload}
                          >
                            Excel Download
                            <FontAwesomeIcon
                              icon="fa-solid fa-file-lines greenSquareBtn"
                              className="ms-2"
                            />
                          </button>
                        </div>

                        {/* <div className="Search me-2">
                            <Button
                              type="button"
                              onClick={getDataAll}
                              className="btn btn-search"
                            >
                              <img src={search1} className="search" alt="" />
                            </Button>
                          </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="border-line mt-3"></div>
                <div className="row mt-4 me-0 ms-0">
                  <div className="data table-responsive">
                    <Table striped bordered hover responsive center>
                      <thead>
                        <tr className="">
                          {" "}
                          <th>
                            <input
                              type="checkbox"
                              value="selectAll"
                              checked={
                                allChecked.length === selectAllChecked.length
                              }
                              onChange={handleChange}
                              id="selectAll"
                              className="me-1"
                            ></input>
                            Select
                          </th>
                          {visible.col1 && <th className="sr">Sr. No.</th>}
                          {visible.col2 && (
                            <th style={{ width: "900px" }} className="tax-name">
                              Name
                            </th>
                          )}{" "}
                          {visible.col3 && (
                            <th style={{ width: "900px" }} className="tax-name">
                              Seller Name
                            </th>
                          )}
                          {visible.col4 && (
                            <th style={{ width: "900px" }} className="tax-name">
                              Short Description
                            </th>
                          )}
                          {visible.col5 && (
                            <th style={{ width: "900px" }} className="tax-name">
                              Total Variants
                            </th>
                          )}
                          {visible.col6 && (
                            <th style={{ width: "900px" }} className="tax-name">
                              Image
                            </th>
                          )}
                          {/* {visible.col7 && (
                              <th
                                style={{ width: "900px" }}
                                className="tax-name"
                              >
                                Manufacturer
                              </th>
                            )} */}
                          {/* {visible.col6 && (
                            <th className="tax-name">Password</th>
                          )} */}
                          {visible.col8 && user?.id !== 1 && (
                            <th style={{ width: "900px" }} className="tax-name">
                              Status
                            </th>
                          )}
                          {visible.col10 && (
                            <th className="tax-name">Best Seller</th>
                          )}
                          {visible.col11 && (
                            <th className="tax-name">Popular Product</th>
                          )}
                          {visible.col11 && (
                            <th className="tax-name">Commission</th>
                          )}
                          {visible.col8 && (
                            <th style={{ width: "900px" }} className="tax-name">
                              {user?.id === 1 ? "View " : "Action "}
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {/* {isAllow.includes(5) ? ( */}
                        {data?.data?.data?.length > 0 ? (
                          data.data.data.map((d, index) => {
                            const paginatedIndex =
                              (onPageChange - 1) * perPage + index + 1;
                            return (
                              <tr className="" key={index}>
                                <td>
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    value={d?.id}
                                    name="perselected"
                                    checked={selectAllChecked.includes(d?.id)}
                                    onChange={handleChange}
                                    id="flexCheckDefault"
                                  ></input>
                                </td>
                                {visible.col1 && <td>{paginatedIndex}.</td>}{" "}
                                {visible.col2 && <td>{d?.name}</td>}
                                {visible.col3 && <td>{d?.user?.first_name}</td>}
                                {visible.col4 && (
                                  <td>{d?.short_description}</td>
                                )}
                                {visible.col5 && (
                                  <td>{d?.product_variants.length}</td>
                                )}
                                {visible.col6 && (
                                  <td>
                                    {d?.image1 && (
                                      <img
                                        src={IMG_URL + d?.image1}
                                        alt="Image"
                                        width="100"
                                        height="100"
                                      />
                                    )}
                                  </td>
                                )}
                                {/* {visible.col7 && (
                                    <td>{d?.product_detail?.manufacturer}</td>
                                  )} */}
                                {/* {visible.col6 && <td>{d?.password}</td>} */}
                                {/* {visible.col6 && <td>******</td>} */}
                                {visible.col8 && user?.id !== 1 && (
                                  <td>
                                    {user?.id !== 1 &&
                                      (d?.stage === "Approved" ? (
                                        <div className="form-check form-switch">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            role="switch"
                                            checked={d.status}
                                            disabled={!isAllow?.includes(89)}
                                            onChange={() => ChangeStatus(d.id)}
                                            id={`statusSwitch_${d.id}`}
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor={`statusSwitch_${d.id}`}
                                          >
                                            {d.status ? "Active" : "Inactive"}
                                          </label>
                                        </div>
                                      ) : (
                                        <p>{d?.stage}</p>
                                      ))}
                                  </td>
                                )}
                                {visible.col10 && (
                                  <td>
                                    <div className="form-check form-switch">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        checked={d.offer_product_status}
                                        onChange={() => ChangeOfferStatus(d.id)}
                                        id={`offerSwitch_${d.id}`}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`offerSwitch_${d.id}`}
                                      >
                                        {d.offer_product_status
                                          ? "Active"
                                          : "Inactive"}
                                      </label>
                                    </div>
                                  </td>
                                )}
                                {visible.col11 && (
                                  <td>
                                    <div className="form-check form-switch">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        checked={d.popular_product}
                                        onChange={() => {
                                          ChangePopularProduct(d.id);
                                        }}
                                        id={`flexSwitchCheckDefault${d?.id}`}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`flexSwitchCheckDefault${d?.id}`}
                                      >
                                        {d.popular_product
                                          ? "Active"
                                          : "Inactive"}
                                      </label>
                                    </div>
                                  </td>
                                )}
                                {visible.col9 && (
                                  <td>
                                    {user?.type === "Seller" ? (
                                      <div className="d-flex justify-content-between align-items-center">
                                        {d?.commission || "N/A"}
                                        <Button
                                          onClick={() =>
                                            handleShowUserCommision(d)
                                          }
                                          type="button"
                                          className="btn btn-primary ms-2"
                                        >
                                          <img
                                            src={pen}
                                            className="pen "
                                            alt=""
                                          />
                                        </Button>
                                      </div>
                                    ) : (
                                      <>{d?.commission || "N/A"}</>
                                    )}
                                  </td>
                                )}
                                {visible.col9 && (
                                  <td>
                                    <div className="d-flex">
                                      <Button
                                        onClick={() => handleShow1(d?.id)}
                                        type="button"
                                        className="btn btn-primary me-1"
                                      >
                                        {user?.id === 1 ? (
                                          <img
                                            src={eye}
                                            className="pen "
                                            alt=""
                                            style={{ width: "20px" }}
                                          />
                                        ) : (
                                          <img
                                            src={pen}
                                            className="pen "
                                            alt=""
                                          />
                                        )}
                                      </Button>

                                      <Button
                                        onClick={() => handleShowPrice(d?.id)}
                                        type="button"
                                        className="btn btn-success me-1"
                                      >
                                        {user?.id === 1 ? (
                                          <>Price Show</>
                                        ) : (
                                          <>Price Update</>
                                        )}
                                      </Button>

                                      {isAllow.includes(90) ? (
                                        <button
                                          onClick={() => {
                                            showDeleteRecord(d?.id, d?.name);
                                          }}
                                          type="button"
                                          className="btn btn-danger"
                                        >
                                          <img
                                            src={basket}
                                            className="pen"
                                            alt=""
                                          />
                                        </button>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                    {/* )} */}
                                  </td>
                                )}
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="10" className="text-center">
                              Data not available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>{" "}
                    <Pagination_Holder
                      onPageChange={currentPage}
                      totalPages={totalPages}
                      handlePageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
      </div>

      {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}
      {showPrice ? (
        <PriceEditOffCanvance
          handleClose={handleClosePrice}
          setShow={setShowPrice}
          show={showPrice}
        />
      ) : (
        ""
      )}

      {userCommision ? (
        <EditUserCommision
          handleClose={handleCloseUserCommision}
          setShow={setUserCommision}
          show={userCommision}
        />
      ) : (
        ""
      )}

      <ModelBulkUpload
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />

      <Toaster position="top-right" />

      {/* <!-- Modal Delete --> */}
      <div className="upload-modal">
        <div
          className={`modal fade ${showDeleteModal ? "show" : ""}`}
          style={{ display: showDeleteModal ? "block" : "none" }}
          id="exampleModaldel"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <h1 className="add-success text-center  mt-2">
                  Are you sure ?
                </h1>
                <p>
                  Do You Really Want to Delete These Record?
                  <br /> This Process CanNot Be Undone{" "}
                </p>
                <div className="button-holder text-center mt-2">
                  <button className="btn btn-yes me-2" onClick={DeleteRecord}>
                    Yes
                  </button>
                  <button className="btn btn-no" onClick={handleDeleteCancel}>
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tables;
